import { Link } from 'react-router-dom';
import { Zap, Twitter, Linkedin, Instagram } from 'lucide-react';
import { Separator } from '@/components/ui/separator';
import { useLanguage } from '@/context/LanguageContext';
import { useSettings } from '@/context/SettingsContext';

export function Footer() {
  const { t } = useLanguage();
  const { settings } = useSettings();

  return (
    <footer className="border-t border-border bg-card">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center border border-primary/20">
                <Zap className="w-4 h-4 text-primary" />
              </div>
              <span className="text-lg font-semibold text-title">THE ACE</span>
            </Link>
            <p className="text-sm text-body leading-relaxed max-w-sm">
              {t('footer.tagline')} Luxury laser branding, personalized engravings, and smart NFC digital experiences.
            </p>
            <div className="flex gap-3 mt-6">
              {[Twitter, Instagram, Linkedin].map((Icon, i) => (
                <button
                  key={i}
                  className="w-9 h-9 rounded-md bg-secondary flex items-center justify-center text-body hover:text-primary hover:bg-primary/10"
                  style={{ transition: 'color 0.2s ease, background 0.2s ease' }}
                >
                  <Icon className="w-4 h-4" />
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-title mb-4">Pages</h4>
            <div className="space-y-3">
              {[
                { to: '/', label: t('nav.home') },
                { to: '/events', label: t('nav.events') },
                { to: '/studio', label: t('nav.studio') },
                { to: '/inquiry', label: t('nav.inquiry') },
              ].map((link) => (
                <Link key={link.to} to={link.to} className="block text-sm text-body hover:text-primary" style={{ transition: 'color 0.2s ease' }}>
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-title mb-4">Contact</h4>
            <div className="space-y-3 text-sm text-body">
              <a href={`mailto:${settings.contact_email}`} className="block hover:text-primary transition-colors">
                {settings.contact_email}
              </a>
              <a href={`tel:+972${settings.contact_phone?.replace(/^0/, '').replace(/[-\s]/g, '')}`} className="block hover:text-primary transition-colors">
                {settings.contact_phone}
              </a>
              <p>Tel Aviv, Israel</p>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-border" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-body">
            &copy; {new Date().getFullYear()} The Ace. {t('footer.rights')}
          </p>
          <div className="flex gap-6 text-xs text-body">
            <span className="hover:text-title cursor-pointer" style={{ transition: 'color 0.2s ease' }}>Privacy</span>
            <span className="hover:text-title cursor-pointer" style={{ transition: 'color 0.2s ease' }}>Terms</span>
            <span className="hover:text-title cursor-pointer" style={{ transition: 'color 0.2s ease' }}>Cookies</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
